<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>医联体</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>背景</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 		2017年4月 国务院办公厅《国务院办公厅关于推进医疗联合体建设和发展的指导意见》，2020年7月，国家卫生健康委出台《医疗联合体管理办法

        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">（试行）》，为推进城市医联体建设指明方向。建设和发展城市医联体有利于促进优质医疗资源的上下贯通，提升基层服务能力，更好实施分级诊疗、满
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">足群众健康需求。</div>
        </div>
        <div class="header-second" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 			平台为城市医联体提供分级诊疗整体方案， 区域三甲医院牵头的医联体可以通过网络培训、手术示教、视频会议等方式对县级医生提供培训提升。



        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">通过远程会诊、远程超声、远程查房等方式，让县级患者就近对接三甲医院的专家。 通过该平台支持，患者在县级医院治疗期间通过远程会诊解决日常诊
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">疗问题，碰到疑难问题通过双向转诊直接转入到三甲医院进一步治疗。 对于上级医院治疗后进入康复阶段的患者可以转入到县级医院进行治疗，康复期通</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;"> 过远程方式支持县级医院完成后续工作，真正达到分级诊疗的目标。  </div>
            <div style="margin-top:25px;">
                <img src="@/assets/image/lianti.png" alt="" >
            </div>
        </div>
        <div class="header-firth" style="margin-top:15px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案框架</span></div>
            <div style="margin-top:20px">
                <img src="@/assets/image/lianti1.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>